// B&B KIGALI live customer support (WhatsApp). Number is display-only, no secret.
export const SUPPORT_WHATSAPP = "250791446979";

export function waSupportLink(message) {
  const text = encodeURIComponent(message || "Hello B&B KIGALI support, I need help.");
  return `https://wa.me/${SUPPORT_WHATSAPP}?text=${text}`;
}
